import type { AuthUser } from '@shared/stores/auth';

/**
 * Mag deze gebruiker de nakijk-wachtrij openen? Het recht `test.grade`, óf aangewezen als nakijker
 * van een toets (besluit PO 16-10). Dezelfde vraag als de poort van de nakijk-API, op één plek: het
 * menu, de route-guard en de knop in het formulierenoverzicht lezen allemaal hier.
 *
 * Bewust een eigen bestand en niet in de auth-store: tientallen tests vervangen die store door een
 * nagemaakte, en een functie die daarin stond zou in elk van die tests ontbreken.
 */
export function mayGradeTests(user: AuthUser | null | undefined): boolean {
  return (user?.permissions ?? []).includes('test.grade') || user?.is_designated_grader === true;
}
